require('./modifyDebitLimitsSliderSection.scss');
//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//@commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const OKSliderInput = require('commonsComponents/OKSliderInput');
//@utilities
const { getCurrencySymbol, formatAmount } = require('utilities/currencyHelper');
//@constants
const { CARD_MODIFY_DEBIT_LIMITS_TYPE_COMMERCE } = require('constants/index');

class ModifyDebitLimitsSliderSection extends React.Component {
    render() {
        const { immCard, immLimits, handleLimitChange, limitAlertVisible, limit, operationType } = this.props;
        const currencySign = operationType === CARD_MODIFY_DEBIT_LIMITS_TYPE_COMMERCE
            ? getCurrencySymbol(immCard.get('limitCommerce'))
            : getCurrencySymbol(immCard.get('limitExtract'));

        const minLabel = `${formatText('modifyDebitLimitsSliderSection-modifyDebitLimitsSliderSection_min')} ${formatAmount(immLimits.first(), undefined, 0)}`;
        const maxLabel = `${formatText('modifyDebitLimitsSliderSection-modifyDebitLimitsSliderSection_max')} ${formatAmount(immLimits.last(), undefined, 0)}`;

        let errorState = false;
        let errorMessage;

        if (limitAlertVisible) {
            errorState = true;
            errorMessage = formatText('modifyDebitLimitsSliderSection-selectedLimitEqualsCurrent');
        }

        return (
            <section className="modify-debit-limits-slider-section">
                <header className="modify-debit-limits-slider-section__header">
                    <FormattedText value="modifyDebitLimitsSliderSection-title" />
                </header>
                <div className="modify-debit-limits-slider-section__body">
                    <div className="modify-debit-limits-slider-section__slider">
                        <OKSliderInput
                            errorMessage={errorMessage}
                            errorState={errorState}
                            minLabel={minLabel}
                            maxLabel={maxLabel}
                            marks={immLimits}
                            defaultValue={limit}
                            onChange={handleLimitChange}
                            unit={currencySign}
                        />
                    </div>
                </div>
            </section>
        );
    }
}

ModifyDebitLimitsSliderSection.propTypes = {
    immCard: PropTypes.object.isRequired,
    limitAlertVisible: PropTypes.bool,
    immLimits: PropTypes.object.isRequired,
    handleLimitChange: PropTypes.func.isRequired,
    limit: PropTypes.number.isRequired,
    operationType: PropTypes.string
};

module.exports = ModifyDebitLimitsSliderSection;
